// extracted by mini-css-extract-plugin
module.exports = {"root":"Input.default_root__3r5j9","text":"Input.default_text__2X2gr","image":"Input.default_image__1STad","checkmark":"Input.default_checkmark__1R1lb"};